export default "__VITE_ASSET__ba417db3__"